export default __webpack_public_path__ + "static/media/web.41fb4ed6.gif";